import { Link } from 'react-router-dom';

// Ends the activity on this device so the next person can't carry on
// with it (shared classroom devices). "Log out" is the words children
// already know; it replaced "Finish safely on this device" (2026-09-28).
export function SafeExitLink({ quiet = false }: { quiet?: boolean }) {
  return (
    <Link
      to="/safe-exit"
      className={
        quiet
          ? 'dm-link-quiet inline-flex min-h-11 items-center'
          : 'mt-8 flex min-h-11 items-center border-t border-line pt-5 font-semibold text-forest-800 underline decoration-forest-800/40 underline-offset-4 hover:decoration-forest-800'
      }
    >
      Log out of this device
    </Link>
  );
}
